import { BaseTableRQ } from "./BaseTable";

export class BinSearchRQ extends BaseTableRQ {
    constructor(pageNum, pageSize, barcode, isGetAll) {
        super(pageNum, pageSize);
        this.barcode = barcode;
        this.isLike = true;
        this.isGetAll = isGetAll;
    }
}